import { FC, useEffect } from 'react';
import { Page } from '@edikk-edikk/country-layout-black';
import { ContentLoader } from '@edikk-edikk/country-common';
import { MetaData } from '@edikk-edikk/country-frontend';
import { useProcessApiError } from '@edikk-edikk/hooks';
import { useApi } from '#hooks/use-api';
import { AdvertDetailContext, AdvertDetailContextType } from '#advertDetail/contexts';
import { Content } from '#advertDetail/components';
import { useAdvertContactsDataControl } from '#advertContacts/hooks';

type PropsType = {
  id: number;
};

const AdvertDetail: FC<PropsType> = ({
  id,
}) => {
  const api = useApi();
  const {
    data,
    error,
    isFetching,
    isError,
  } = api.getApiAdvertDetail().useInitQuery(id);
  const { setContactData, removeContactData } = useAdvertContactsDataControl();
  useProcessApiError(error);

  useEffect(() => () => {
    removeContactData();
  }, [removeContactData]);

  useEffect(() => {
    if (!data) {
      return;
    }

    setContactData(data.advert.contactData);
  }, [data, setContactData]);

  if (isFetching) {
    return (
      <Page withoutWrapContainer>
        <ContentLoader />
      </Page>
    );
  }

  if (isError) {
    return null;
  }

  const advertDetailContextType: AdvertDetailContextType = {
    isSlave: false,
    advert: data.advert,
    reviews: data.reviews,
  };

  return (
    <AdvertDetailContext value={advertDetailContextType}>
      <MetaData seo={data.seo} />
      <Page withoutPaddingTop withoutGap dataAttributeList={{ id: data.advert.id }}>
        <Content />
      </Page>
    </AdvertDetailContext>
  );
};

export { AdvertDetail };
